import {Component} from 'panel';
import {setFlag} from 'common/report/queries/legacy-django-api/user-flags';

import template from './index.jade';
import css from './index.styl?inline';

type MessageBannerState = {
  visible: boolean;
};

/**
 * NOTE: deprecated
 * Use global-actions-bar banner-bar instead
 */
class ReportMessageBanner extends Component<MessageBannerState> {
  static get attrsSchema() {
    return {
      closeable: `boolean`,
      clickable: `boolean`,
      message: `string`,
      flag: `string`,
      visible: `boolean`,
    };
  }

  get config() {
    return {
      template,
      css,
      useShadowDom: true,
      defaultState: {
        visible: false,
      },
      helpers: {
        showBanner: () => {
          this.dispatchEvent(new CustomEvent(`open`));
          this.update({visible: true});
        },

        hideBanner: () => {
          if (this.attr(`flag`)) {
            // TODO: do this via imported util function and don't rely on universal imported global
            setFlag(this.attr(`flag`));
          }

          this.dispatchEvent(new CustomEvent(`close`));
          this.update({visible: false});
        },
      },
    };
  }

  attributeChangedCallback(attr, oldValue, newValue) {
    super.attributeChangedCallback(attr, oldValue, newValue);
    if (attr === `visible`) {
      // visible attr change overrides internal state
      this.update({visible: this.attr(attr)});
    } else if (attr === `flag`) {
      if (!mp.report.globals.flags[this.attr(attr)]) {
        this.helpers.showBanner();
      }
    }
  }
}

customElements.define(`mp-report-message-banner`, ReportMessageBanner);
